export const StateOfGoodsIcons = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <g fill="none">
        <path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
        <path
          fill="currentColor"
          d="M18.763 14.214a1 1 0 0 1 1.302.268l.064.098L21.526 17c.745 1.29-.132 2.893-1.585 2.995l-.147.005h-6.38l.415.414a1 1 0 0 1-1.32 1.498l-.095-.084l-2.115-2.115a1 1 0 0 1-.194-.267a1 1 0 0 1 .121-1.08l.036-.04l2.152-2.154a1 1 0 0 1 1.498 1.32l-.083.094l-.415.414h6.38l-1.397-2.42a1 1 0 0 1 .366-1.366M8.703 9.625l.777 2.898a1 1 0 1 1-1.932.518l-.152-.566L4.206 18H7a1 1 0 1 1 0 2H4.206c-1.54 0-2.502-1.667-1.732-3l3.19-5.525l-.566.151a1 1 0 0 1-.517-1.932l2.897-.776a1 1 0 0 1 1.225.707m4.942-6.263l.087.138l3.19 5.525l.152-.566a1 1 0 0 1 1.955.404l-.023.114l-.777 2.898a.996.996 0 0 1-1.099.732l-.125-.025l-2.898-.776a1 1 0 0 1 .403-1.956l.114.024l.566.151L12 4.5l-1.397 2.42a1 1 0 0 1-1.785-.896l.053-.104l1.397-2.42c.715-1.238 2.425-1.327 3.282-.265z"
        />
      </g>
    </svg>
  );
};

export const NewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="m8.6 22.5l-1.9-3.2l-3.6-.8l.35-3.7L1 12l2.45-2.8l-.35-3.7l3.6-.8l1.9-3.2L12 2.95l3.4-1.45l1.9 3.2l3.6.8l-.35 3.7L23 12l-2.45 2.8l.35 3.7l-3.6.8l-1.9 3.2l-3.4-1.45zm2.35-6.95L16.6 9.9l-1.4-1.45l-4.25 4.25l-2.15-2.1L7.4 12z"
      />
    </svg>
  );
};
